import { Splash } from 'core/styles/Banner'
import styled from 'styled-components'
import { lighter } from '../helpers/color'
import { breakpoint } from '../layout/styles'
import { Container } from '../styles/Container'
import { Grid, Cell } from '../styles/Grid'
import Image from 'next/image';
import { useState } from 'react';

const LogoShowcase = ({ data }: any) =>
  <Wrapper background={lighter(data.background_color?.[0]?.background)}>
    <Center>
      <SectionTitle>{data.title}</SectionTitle>
      <p>{data.description}</p>
    </Center>
    <LogoContainer>
      {data.logos.map((logo: any) =>
        <Section key={logo.uid}>
          <LogoImage src={logo.url} alt={logo.description || 'logo'} />
        </Section>)}
    </LogoContainer>
  </Wrapper>

export default LogoShowcase

const LogoImage = ({ src, alt }: { src: string; alt: string }) => {
  const [dimensions, setDimensions] = useState<{ width: number; height: number } | null>(null);

  return (
    <Image
      src={src}
      alt={alt}
      width={dimensions?.width || 200}
      height={dimensions?.height || 75}
      objectFit="contain"
      onLoadingComplete={({ naturalWidth, naturalHeight }) => {
        setDimensions({ width: naturalWidth, height: naturalHeight });
      }}
    />
  );
};

const LogoContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-around;
  @media ${breakpoint.desktop} {
    flex-wrap: nowrap;
    justify-content: center;
  }
`

const Center = styled.div`
  text-align: center;
  p {
    margin: 24px 0;
  }
`

export const Wrapper = styled(Container)`
  margin: 36px 20px;
  background: ${props => props.background || 'none'};
  padding: 20px;
  color: var(--text);
  @media ${breakpoint.desktop} {
    margin: 100px auto 48px;
    padding: 36px;
  }
`

const Section = styled(Cell)`
  text-align: center; 
  margin: 16px;
  @media ${breakpoint.desktop} {
    width: 33.3333%;
    max-width: 200px;
    margin: 24px;
  }
  &:first-child {
    margin-left: 0;
  }
  &:last-child {
    margin-right: 0;
  }
  h4 {
    font-size: 22px;
    font-style: normal;
    font-weight: 600;
    text-align: center;
  }
  p {
    font-size: 14px;
    @media ${breakpoint.desktop} {
      font-size: 16px;
    }
  }
`
const SectionTitle = styled.h3`
  margin: 0;
  text-align: center;
  font-style: normal;
  font-weight: 700;
  font-size: 28px;
  color: var(--primary);
  @media ${breakpoint.desktop} {
    font-size: 36px;
  }
`